import Geometry from 'ol/geom/Geometry';
import { fromCircle } from 'ol/geom/Polygon';
import { WKT, GeoJSON } from 'ol/format';
import { CIRCLE } from 'client/utils/constants/geometryType';

const validateGeometry = (geometry, sides) => {
    let validGeometry = geometry;

    if (geometry?.getType() === CIRCLE) {
        try {
            validGeometry = fromCircle(geometry, sides);
        } catch (err) {
            throw new Error(err);
        }
    }
    return validGeometry;
};

export default {
    toWKT: (geometry, sides = 64) => {
        if (!geometry || !(geometry instanceof Geometry)) {
            throw new Error('geometry is NOT instance of ol/geom/Geometry');
        }
        const validGeometry = validateGeometry(geometry, sides);

        return new WKT().writeGeometry(validGeometry);
    },
    toGeoJSON: (geometry, sides = 64, JSON = false) => {
        if (!geometry || !(geometry instanceof Geometry)) {
            throw new Error('geometry is NOT instance of ol/geom/Geometry');
        }
        const validGeometry = validateGeometry(geometry, sides);

        if (JSON) {
            return new GeoJSON().writeGeometryObject(validGeometry);
        }

        return new GeoJSON().writeGeometry(validGeometry);
    }
};
